import React from "react"

const JourneyContext = React.createContext({})

const { Provider, Consumer } = JourneyContext

export { Provider, Consumer, JourneyContext }
